import { CasMultiSelect, ICasMultiSelect } from 'src/compass/shared/components';
import { useRetrieveSelectListOptions } from 'src/compass/shared/components/CasSelect/CasEntitySelect';

const entity = 'Tag';
const activeOnlyParams = { isActive: true };

export function CasTagMultiSelect(props: Omit<ICasMultiSelect, 'options'>) {
  const { options, isLoading } = useRetrieveSelectListOptions(entity, {
    ...props,
    params: activeOnlyParams,
  });
  // props first: this wrapper owns `options`, so a caller-passed (or undefined)
  // options must not clobber the fetched list.
  return <CasMultiSelect {...props} options={options} loading={isLoading} />;
}
